import { Component, HostBinding, OnInit } from '@angular/core';
import { LayoutService } from '../_services/layout.service';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { AuthService } from '../_services/auth.service';
import { RouterLink, RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  LanguageService,
  SupportedLanguages,
} from '../_services/language.service';
import { LinkOpenerService } from '../_services/link-opener.service';
import { FeedbackFormComponent } from '../forms/feedback-form/feedback-form.component';
import { SharedService } from '../_services/shared.service';
import { StatusService } from '../_services/status.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-nav',
  imports: [
    RouterLink,
    RouterModule,
    MatMenuModule,
    UpperCasePipe,
    MatIcon,
    TranslateModule,
    AsyncPipe,
  ],
  templateUrl: './nav.component.html',
  standalone: true,
  styleUrls: ['./nav.component.css'],
})
export class NavComponent implements OnInit {
  protected readonly FeedbackFormComponent = FeedbackFormComponent;
  private instructionsUrl =
    'https://bernerfachhochschule.sharepoint.com/sites/mybfh-bernie-rdm-de';
  public version!: string;
  public backendVersion?: string;
  public isCollapsed: boolean = false;

  themeSwitchChecked: boolean = false;
  activeLanguage: SupportedLanguages = SupportedLanguages.GERMAN;
  remainingLanguages: SupportedLanguages[] = [];

  @HostBinding('class.collapsed') get collapsed() {
    return this.isCollapsed;
  }

  constructor(
    public layoutService: LayoutService,
    private languageService: LanguageService,
    private linkOpenerService: LinkOpenerService,
    public authService: AuthService,
    private sharedService: SharedService,
    private statusService: StatusService,
  ) {}

  ngOnInit() {
    this.languageService.activeLanguage$.subscribe((activeLanguage) => {
      this.activeLanguage = activeLanguage;
      this.updateRemainingLanguages();
    });
    this.layoutService.isCollapsed$.subscribe((isCollapsed) => {
      this.isCollapsed = isCollapsed;
    });

    this.version = environment.version;

    this.authService.isLoggedIn$.subscribe((isLoggedIn) => {
      if (isLoggedIn && !this.backendVersion) {
        this.statusService.getVersion().subscribe({
          next: (versionInfo) => (this.backendVersion = versionInfo.version),
        });
      }
    });

    this.initTheme();
  }

  initTheme() {
    const darkThemeSelected = localStorage.getItem('themeSwitch') === 'dark';
    this.themeSwitchChecked = darkThemeSelected;
    this.layoutService.updateTheme(darkThemeSelected);
  }

  changeLanguage(language: SupportedLanguages) {
    this.languageService.setActiveLanguage(language);
  }

  openUrlLocalized(event: Event) {
    event.preventDefault();
    this.linkOpenerService.openMyBFHLink(this.instructionsUrl);
  }

  openForm(event: Event) {
    event.preventDefault();
    const formData = {
      formRef: FeedbackFormComponent,
      isTeam: false,
    };
    this.sharedService.toggleModal('Feedback', formData);
  }

  toggleDarkMode(): void {
    this.themeSwitchChecked = !this.themeSwitchChecked;
    this.layoutService.resetTheme(this.themeSwitchChecked);
  }

  toggleSidebar(): void {
    this.layoutService.toggleSidebar();
  }

  async login() {
    await this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  private updateRemainingLanguages() {
    this.remainingLanguages = this.languageService.languages.filter(
      (language) => language !== this.activeLanguage,
    );
  }
}
